import type { AccessQueueItemPublic, AccessQueueType } from '@accounts/shared';
import { ACCESS_QUEUE_TYPES } from '@accounts/shared';

import { type ItStanding, isWithIt } from './itEmail/picker';
import { WAITING_ON_IT_LANE } from './itEmail/waiting';

/**
 * THE OVERVIEW'S TILES (spec row 18): Requests, Needs access, Remove access, App deactivations
 * (administrators only), Waiting on IT, Overdue. Each key is the Queue's `?type=` for its lane.
 */
export type OverviewTileKey =
  | AccessQueueType
  | 'deactivations'
  | typeof WAITING_ON_IT_LANE
  | 'overdue';

export function overviewTileKeys(admin: boolean): OverviewTileKey[] {
  return [
    ...ACCESS_QUEUE_TYPES,
    ...(admin ? (['deactivations'] as const) : []),
    WAITING_ON_IT_LANE,
    'overdue',
  ];
}

/**
 * Each work lane's total and overdue count, as the Queue draws its lanes: a record in a SENT IT
 * email has left its lane for Waiting on IT, so its lane tile does not count it twice.
 */
export function laneCounts(
  items: readonly AccessQueueItemPublic[],
  standing: ItStanding,
): Record<AccessQueueType, { n: number; overdue: number }> {
  const counts = Object.fromEntries(
    ACCESS_QUEUE_TYPES.map((type) => [type, { n: 0, overdue: 0 }]),
  ) as Record<AccessQueueType, { n: number; overdue: number }>;
  for (const item of items) {
    if (isWithIt(item, standing)) continue;
    counts[item.type].n += 1;
    if (item.overdue) counts[item.type].overdue += 1;
  }
  return counts;
}
